import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ page, totalPages, onChange, testId = 'pagination' }) {
  if (!totalPages || totalPages <= 1) return null;
  const canPrev = page > 1;
  const canNext = page < totalPages;
  return (
    <div className="flex items-center justify-between border-t border-zinc-200 px-4 py-3 bg-white" data-testid={testId}>
      <div className="text-xs text-zinc-500 font-mono">
        Page <span className="text-zinc-900 font-medium">{page}</span> of <span className="text-zinc-900 font-medium">{totalPages}</span>
      </div>
      <div className="flex items-center gap-1">
        <button
          onClick={() => canPrev && onChange(page - 1)}
          disabled={!canPrev}
          className="w-8 h-8 grid place-items-center rounded-md border border-zinc-200 hover:bg-zinc-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          data-testid="pagination-prev"
        >
          <ChevronLeft className="w-4 h-4" />
        </button>
        <button
          onClick={() => canNext && onChange(page + 1)}
          disabled={!canNext}
          className="w-8 h-8 grid place-items-center rounded-md border border-zinc-200 hover:bg-zinc-50 disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
          data-testid="pagination-next"
        >
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
